module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-tee/21-2675ab79fcd9b812a1733a2faf7dd4b9.jpg";